var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119 76 L 343.871094 76 L 343.871094 300 L 119 300 Z M 119 76 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 243 253 L 335 253 L 335 326.792969 L 243 326.792969 Z M 243 253 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32 47.621094 L 256 47.621094 L 256 271 L 32 271 Z M 32 47.621094 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 184 192 L 195.816406 192 L 195.816406 214 L 184 214 Z M 184 192 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 150.332031 192 L 162 192 L 162 214 L 150.332031 214 Z M 150.332031 192 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 166 187.5 L 180 187.5 L 180 218.867188 L 166 218.867188 Z M 166 187.5 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 119.800781 187.898438 C 119.800781 249.472656 169.929688 299.410156 231.773438 299.410156 C 293.605469 299.410156 343.730469 249.472656 343.730469 187.898438 C 343.730469 126.308594 293.605469 76.386719 231.773438 76.386719 C 169.929688 76.386719 119.800781 126.308594 119.800781 187.898438 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 299.621094 253.660156 L 243.175781 272.386719 L 334.535156 326.792969 Z M 299.621094 253.660156 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.899597%,32.159424%,100%)",
      fillOpacity: 1
    },
    d: "M 255.996094 159.132812 C 255.996094 220.707031 205.867188 270.644531 144.023438 270.644531 C 82.191406 270.644531 32.046875 220.707031 32.046875 159.132812 C 32.046875 97.542969 82.191406 47.621094 144.023438 47.621094 C 205.867188 47.621094 255.996094 97.542969 255.996094 159.132812 "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(54.899597%,32.159424%,100%)",
      fillOpacity: 1
    },
    d: "M 76.175781 224.894531 L 132.621094 243.621094 L 41.261719 298.027344 Z M 76.175781 224.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 192.78125 135.78125 L 77.339844 135.78125 L 77.339844 128.675781 L 192.78125 128.675781 L 192.78125 135.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 192.78125 154.351562 L 77.339844 154.351562 L 77.339844 147.246094 L 192.78125 147.246094 L 192.78125 154.351562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 192.78125 171.980469 L 77.339844 171.980469 L 77.339844 164.875 L 192.78125 164.875 L 192.78125 171.980469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 149.328125 187.632812 L 77.339844 187.632812 L 77.339844 180.542969 L 149.328125 180.542969 L 149.328125 187.632812 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 186.171875 192.902344 L 185.125 193.773438 C 184.777344 194.121094 184.601562 194.820312 184.949219 195.167969 L 191.585938 203.183594 L 184.949219 211.199219 C 184.601562 211.546875 184.601562 212.246094 185.125 212.59375 L 186.171875 213.464844 C 186.523438 213.8125 187.21875 213.8125 187.570312 213.289062 L 195.601562 203.707031 C 195.777344 203.359375 195.777344 203.007812 195.601562 202.660156 L 187.570312 193.078125 C 187.21875 192.726562 186.695312 192.554688 186.171875 192.902344 Z M 186.171875 192.902344 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 159.976562 213.464844 L 161.023438 212.59375 C 161.375 212.246094 161.546875 211.546875 161.199219 211.199219 L 154.386719 203.183594 L 161.023438 195.167969 C 161.375 194.820312 161.375 194.121094 160.847656 193.773438 L 159.976562 192.902344 C 159.453125 192.554688 158.929688 192.726562 158.578125 193.078125 L 150.546875 202.660156 C 150.371094 203.007812 150.371094 203.359375 150.546875 203.707031 L 158.578125 213.289062 C 158.929688 213.640625 159.453125 213.8125 159.976562 213.464844 Z M 159.976562 213.464844 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(75.289917%,94.119263%,96.859741%)",
      fillOpacity: 1
    },
    d: "M 175.867188 188.371094 L 166.089844 217.648438 C 165.914062 218.34375 166.4375 218.867188 166.960938 218.867188 L 168.535156 218.867188 C 169.058594 218.867188 169.582031 218.519531 169.757812 217.996094 L 179.535156 188.71875 C 179.710938 188.023438 179.1875 187.5 178.664062 187.5 L 177.089844 187.5 C 176.566406 187.5 176.042969 187.847656 175.867188 188.371094 Z M 175.867188 188.371094 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da8d8a82.svg";
export { ForwardRef as ReactComponent };